import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Rect from './Rect';
import Text from './Text';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Product__Wrapper",
  componentId: "owcdcd-0"
})(["display:flex;"]);
var Product = function Product(_ref) {
  var rows = _ref.rows,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Rect, {
    size: size
  }), /*#__PURE__*/React.createElement(Text, {
    rows: rows
  }));
};
Product.defaultProps = {
  size: 'sz40',
  rows: 2
};
Product.propTypes = {
  rows: PropTypes.number,
  size: PropTypes.string
};
export default Product;